<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Payment Receipts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      ledgerDetails: {
        payDetails: [],
        patient: "",
      },

      //
      title: "Payment Receipts",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Payment Receipts",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "visit.patient.patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "visit.patient.patient_contact",
          sortable: true,
          label: "CONTACT",
        },

        {
          key: "totalBill",
          sortable: true,
          label: "TOTAL AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("payments", ["PaymentsReciept"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.PaymentsReciept ? this.PaymentsReciept.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PaymentsReciept ? this.PaymentsReciept.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPayReceipts: "payments/fetchPaymentsReceipt",
    }),

    // REMOVE COMMA SEPARATORS
    remove_commas(data) {
      var removed = data.replace(/,/g, "");
      return parseInt(removed);
    },
    //END  REMOVE

    // COMMA SEPARATORS
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    // LEDGER MODEL
    viewLedger(data) {
      this.ledgerDetails.patient = data.visit.patient.patient_name;
      this.ledgerDetails.payDetails = data.paydetails;
      this.ledgerDetails.pay_id = data.id;
    },

    // END LEDGER MODEL
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reprintReceipt(ledger) {
      window.open(
        `https://${window.location.host}/preciept/reprint.php?id=${btoa(ledger.id)}`
      );

      // this.$router.push(
      //   `/receiptReprint/${btoa(this.ledgerDetails.pay_id)}/${btoa(ledger.id)}/${btoa(
      //     ledger.amount_paid
      //   )}/${btoa(ledger.new_balance)}/${btoa(ledger.date)}`
      // );
    },
  },
  created() {
    this.FetchPayReceipts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="PaymentsReciept"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <button
                    v-b-modal.modal-lg
                    class="btn btn-primary btn-sm"
                    @click="viewLedger(data.item)"
                  >
                    Ledger
                  </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!PaymentsReciept" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- LEDGER MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal id="modal-lg" size="lg" hide-footer>
                    <template #modal-title
                      ><p class="text-uppercase">
                        Payment Ledger FOR {{ ledgerDetails.patient }}
                      </p></template
                    >
                    <div class="table-responsive">
                      <table class="table table-bordered border-primary mb-0">
                        <thead>
                          <tr>
                            <th>DATE</th>
                            <th>AMOUNT PAID</th>
                            <th>BALANCE</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(ledger, index) in ledgerDetails.payDetails"
                            :key="index"
                          >
                            <td>{{ ledger.date }}</td>
                            <td>{{ thousandSeparator(ledger.amount_paid) }}</td>
                            <td>{{ thousandSeparator(ledger.new_balance) }}</td>
                            <td>
                              <button
                                v-if="user_permissions.reprint_payment_receipt"
                                @click="reprintReceipt(ledger)"
                                class="btn btn-success btn-sm"
                              >
                                <i class="fa fa-print"></i> Reprint
                              </button>
                              <button v-else disabled class="btn btn-success btn-sm">
                                <i class="fa fa-ban"></i> Reprint
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END LEDGER MODEL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
